import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import authReducer from "./authSlice";
import exploreSlice from "./exploreSlice";
import projectSlice from "./projectSlice";
import navbarSlice from "./navbarSlice";
import charitySlice from "./charitySlice";
import themeReducer from "./themeSlice";
import userSelectSlice from "./userSelectSlice";
import userReducer from "./userTypeSlice";
import subscriptionReducer from "./subscriptionSlice";

// Configure persist for auth specifically
const authPersistConfig = {
  key: "auth",
  storage,
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    explore: exploreSlice,
    project: projectSlice,
    navbar: navbarSlice,
    charity: charitySlice,
    darkMode: themeReducer,
    userSelectedType: userSelectSlice,
    user: userReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;